import React from "react";

function NoInternet() {
    return <div>NoInternet</div>;
}

export default NoInternet;
